module.exports = __webpack_public_path__ + "/build/web/images/testimonials-left-1-2.90b0186f7cf1c6a898d532a0b2f0d2cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-left-1-2.jpg
// module id = 197
// module chunks = 13